(() => {
  'use strict';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const keys = ['type', 'color', 'size', 'availability'];
  const emptyState = () => ({type: [], color: [], size: [], availability: [], min: null, max: null});
  const priceNumber = value => value === '' || value == null || !Number.isFinite(Number(value)) ? null : Math.max(0, Math.round(Number(value) * 100));
  function matches(product, state, omit) {
    if (omit !== 'type' && state.type.length && !state.type.includes(product.type)) return false;
    if (omit !== 'availability' && state.availability.length && !state.availability.includes(product.available ? 'in' : 'out')) return false;
    return product.variants.some(variant => {
      if (omit !== 'color' && state.color.length && !state.color.includes(variant.options[product.colorIndex])) return false;
      if (omit !== 'size' && state.size.length && !state.size.includes(variant.options[product.sizeIndex])) return false;
      // Color, size, stock and price must match the same variant.
      if (omit !== 'availability' && state.availability.length === 1 && state.availability[0] === 'in' && !variant.available) return false;
      if (omit !== 'price' && state.min !== null && variant.price < state.min) return false;
      if (omit !== 'price' && state.max !== null && variant.price > state.max) return false;
      return true;
    });
  }
  function readState(search) {
    const params = new URLSearchParams(search), state = emptyState();
    keys.forEach(key => state[key] = [...new Set(params.getAll('mw_' + key))]);
    state.min = priceNumber(params.get('mw_min'));
    state.max = priceNumber(params.get('mw_max'));
    if (state.min !== null && state.max !== null && state.min > state.max) [state.min, state.max] = [state.max, state.min];
    return state;
  }
  function stateUrl(state, url) {
    const next = new URL(url);
    keys.forEach(key => {next.searchParams.delete('mw_' + key); state[key].forEach(value => next.searchParams.append('mw_' + key, value));});
    ['min', 'max'].forEach(key => {next.searchParams.delete('mw_' + key); if (state[key] !== null) next.searchParams.set('mw_' + key, String(state[key] / 100));});
    next.searchParams.delete('page');
    return next;
  }
  window.MWCollectionUtils = {matches, readState, stateUrl, priceNumber};
  const arrow = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none'); svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm5 9 7 7 7-7'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.4');
    svg.append(path); return svg;
  };
  const verifiedColorSwatches=new Map();
  function colorHex(value) {
    if(verifiedColorSwatches.has(value))return verifiedColorSwatches.get(value);
    const colors = {black:'#111',white:'#fafafa',beige:'#e8d9b3',brown:'#94572f',gray:'#8d8d8d',grey:'#8d8d8d',navy:'#25206e',blue:'#87a7bf',green:'#7f9476',pink:'#e6bdc9',purple:'#b2a2c6',yellow:'#ead794',orange:'#de9445',red:'#ac3335',taupe:'#ac9c89',silver:'#c4c4c4',charcoal:'#454747',ivory:'#eee8d9',coconut:'#8c7162',gustard:'#e8d990',offwhite:'#f4efe3'};
    const lower = String(value).toLowerCase().replace(/[^a-z]/g, '');
    return colors[lower] || Object.entries(colors).find(([name]) => lower.includes(name))?.[1] || '#ddd';
  }
  function setup(section) {
    if (section.dataset.collectionBound) return;
    section.dataset.collectionBound = 'true';
    const drawer = $('[data-collection-drawer]', section), form = $('[data-collection-filter-form]', section), open = $('[data-collection-open]', section);
    const grid = $('[data-collection-grid]', section), facets = $('[data-collection-facets]', section), count = $('[data-collection-count]', section);
    const more = $('[data-collection-more]', section), active = $('[data-collection-active]', section), error = $('[data-collection-error]', section);
    const pageSize = Number(section.dataset.pageSize) || 24, total = Number(section.dataset.total), pages = Number(section.dataset.pages) || 1;
    const currency = section.dataset.currency || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
    const symbol = new Intl.NumberFormat('en', {style:'currency', currency}).formatToParts(0).find(part => part.type === 'currency')?.value || currency;
    let products = [], applied = readState(location.search), limit = pageSize, ready = false, maxPrice = 0, closingTimer;
    function collect(scope, page) {
      $$('[data-collection-item]', scope).forEach((node, index) => {
        const product = JSON.parse($('[data-collection-product]', node).textContent);
        (product.colorGroups||[]).forEach(group=>{if(group.swatch)verifiedColorSwatches.set(group.name,group.swatch);});
        if (products.some(item => item.id === product.id)) return;
        products.push({...product, node, order: (page - 1) * 250 + index});
        if (scope !== section) grid.append(node);
      });
    }
    collect(section, Number(section.dataset.currentPage) || 1);
    function closeDrawer() {
      if (!drawer.open || drawer.classList.contains('is-closing')) return;
      if (matchMedia('(prefers-reduced-motion:reduce)').matches) {drawer.close(); return;}
      drawer.classList.add('is-closing');
      const finish = () => {clearTimeout(closingTimer);drawer.removeEventListener('animationend',onEnd);drawer.classList.remove('is-closing');if (drawer.open) drawer.close();};
      const onEnd = event => {if (event.target === drawer && event.animationName === 'mw-collection-exit') {drawer.removeEventListener('animationend',onEnd);finish();}};
      drawer.addEventListener('animationend',onEnd);
      closingTimer = setTimeout(finish, 230);
    }
    function openDrawer() {
      if (!ready) return;
      clearTimeout(closingTimer); drawer.classList.remove('is-closing');
      fillForm(applied); updateCounts();
      drawer.returnFocus = open; drawer.showModal();
      document.documentElement.style.overflow = 'hidden'; open.setAttribute('aria-expanded', 'true');
      $('[data-collection-close]', drawer).focus({preventScroll:true});
    }
    open.addEventListener('click', openDrawer);
    $('[data-collection-close]', drawer).addEventListener('click', closeDrawer);
    drawer.addEventListener('cancel', event => {event.preventDefault();closeDrawer();});
    drawer.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const box = drawer.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDrawer();
    });
    drawer.addEventListener('close', () => {
      open.setAttribute('aria-expanded', 'false');
      if (!$('dialog[open]')) document.documentElement.style.overflow = '';
      open.focus({preventScroll:true});
    });
    function group(key, title, values) {
      if (!values.length) return;
      const details = document.createElement('details'); details.className = 'mw-collection-facet'; details.open = true;
      details.dataset.facet = key;
      const summary = document.createElement('summary'); summary.append(document.createTextNode(title), arrow());
      const list = document.createElement('div'); list.className = 'mw-collection-facet-options';
      values.forEach((value, index) => {
        const label = document.createElement('label'); label.className = 'mw-collection-choice';
        const input = document.createElement('input'); input.type = 'checkbox'; input.name = key; input.value = value;
        if (key === 'color') {input.dataset.color = ''; input.style.setProperty('--filter-color', colorHex(value));}
        const text = document.createElement('span'); text.textContent = key === 'availability' ? value === 'in' ? 'In stock' : 'Out of stock' : value;
        const amount = document.createElement('small'); amount.dataset.facetCount = ''; amount.setAttribute('aria-hidden', 'true');
        label.append(input, text, amount); if (index >= 5) label.dataset.extraOption = '';
        list.append(label);
      });
      details.append(summary, list);
      if (values.length > 5) {
        const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'mw-collection-show-more'; toggle.textContent = 'Show More'; toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', () => {const expanded = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(expanded));toggle.textContent = expanded ? 'Show Less' : 'Show More';$$('[data-extra-option]', details).forEach(label => label.hidden = !expanded && !$('input',label).checked);});
        details.append(toggle);
      }
      facets.append(details);
    }
    function buildFacets() {
      facets.replaceChildren();
      const values = key => [...new Set(products.flatMap(product => key === 'type' ? [product.type] : product.variants.map(v => v.options[product[key + 'Index']])).filter(Boolean))];
      const alpha = (a,b) => a.localeCompare(b, undefined, {numeric:true});
      group('type', 'Product type', values('type').sort(alpha));
      group('color', 'Color', values('color').sort(alpha));
      const price = document.createElement('details'); price.className = 'mw-collection-facet'; price.open = true;price.dataset.facet = 'price';
      const summary = document.createElement('summary'); summary.append(document.createTextNode('Price'), arrow()); price.append(summary);
      const range = document.createElement('div');range.className = 'mw-collection-price-range';
      const fields = document.createElement('div');fields.className = 'mw-collection-price-fields';
      ['min','max'].forEach(key => {
        const input = document.createElement('input'); input.type = 'range'; input.min = '0'; input.max = String(maxPrice / 100);input.step = '.01';input.dataset.priceRange = key;input.setAttribute('aria-label', key === 'min' ? 'Minimum price slider' : 'Maximum price slider');range.append(input);
        const label = document.createElement('label'), caption = document.createElement('span');caption.textContent = key === 'min' ? 'From' : 'To';
        const wrapper = document.createElement('div');wrapper.className = 'mw-collection-price-input';
        const currencySymbol = document.createElement('span');currencySymbol.textContent = symbol;
        const number = document.createElement('input');number.type = 'number';number.name = key;number.min = '0';number.max = String(maxPrice/100);number.step = '.01';number.inputMode = 'decimal';number.dataset.priceInput = key;number.setAttribute('aria-label',key === 'min' ? 'Minimum price' : 'Maximum price');wrapper.append(currencySymbol, number);label.append(caption,wrapper);fields.append(label);
      });
      price.append(range,fields);facets.append(price);
      const sizes = values('size'), order = ['XXS','2XS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','XXXXL','4XL','XXXXXL','5XL'];
      sizes.sort((a,b) => {const left=order.indexOf(a.toUpperCase()),right=order.indexOf(b.toUpperCase());return left >= 0 && right >= 0 ? left-right : left>=0?-1:right>=0?1:alpha(a,b);});
      group('size', 'Size', sizes);
      group('availability', 'Availability', ['in','out']);
    }
    function fillForm(state) {
      keys.forEach(key => $$(`input[name="${key}"]`, form).forEach(input => input.checked = state[key].includes(input.value)));
      const low = Math.min(state.min ?? 0,maxPrice),high = Math.min(state.max ?? maxPrice,maxPrice);
      $('[data-price-input=min]', form).value = (low / 100).toFixed(2);
      $('[data-price-input=max]', form).value = (high / 100).toFixed(2);
      updateRanges(low,high);
      $$('[data-extra-option]', form).forEach(label => label.hidden = !$('input',label).checked && label.closest('details').querySelector('button').getAttribute('aria-expanded') !== 'true');
    }
    function updateRanges(low,high) {
      $('[data-price-range=min]', form).value = String(low/100); $('[data-price-range=max]', form).value = String(high/100);
      const range = $('.mw-collection-price-range', form);range.style.setProperty('--range-start',(maxPrice ? low/maxPrice*100 : 0)+'%');range.style.setProperty('--range-end',(maxPrice ? high/maxPrice*100 : 100)+'%');
    }
    function formState() {
      const state = emptyState();keys.forEach(key => state[key] = $$(`input[name="${key}"]:checked`, form).map(input => input.value));
      state.min = priceNumber($('[data-price-input=min]',form).value);state.max = priceNumber($('[data-price-input=max]',form).value);
      if (state.min === 0) state.min = null;
      if (state.max === maxPrice) state.max = null;
      return state;
    }
    function updateCounts() {
      const state = formState();
      $$('input[type=checkbox]', form).forEach(input => {
        const test = {...state, [input.name]:[input.value]};
        const matchesCount = products.filter(product => matches(product,test)).length;
        input.disabled = !input.checked && matchesCount === 0;
        $('[data-facet-count]',input.closest('label')).textContent = String(matchesCount);
      });
    }
    form.addEventListener('input', event => {
      const input = event.target, key = input.dataset.priceRange || input.dataset.priceInput;
      if (!key) return;
      let value = Math.min(maxPrice, priceNumber(input.value) ?? (key === 'max' ? maxPrice : 0));
      const other = priceNumber($(`[data-price-input=${key === 'min' ? 'max' : 'min'}]`,form).value) ?? (key === 'min' ? maxPrice : 0);
      value = key === 'min' ? Math.min(value,other) : Math.max(value,other);
      // Keep editing the number field natural; synchronize its pair and both sliders.
      if (input.dataset.priceRange) $(`[data-price-input=${key}]`,form).value = (value / 100).toFixed(2);
      else if (priceNumber(input.value) !== value && input.value !== '') input.value = (value / 100).toFixed(2);
      const low = key === 'min' ? value : other,high = key === 'max' ? value : other;
      updateRanges(low,high);updateCounts();
    });
    form.addEventListener('change', () => updateCounts());
    function render() {
      const matching = products.filter(product => matches(product,applied));
      const shown = new Set(matching.slice(0,limit));products.forEach(product => product.node.hidden = !shown.has(product));
      count.textContent = `${Math.min(limit,matching.length)} of ${matching.length} products`;
      more.hidden = limit >= matching.length;$('[data-collection-empty]', section).hidden = matching.length !== 0;
      active.replaceChildren();
      const chip = (text,key,value) => {
        const button = document.createElement('button');button.type='button';button.className='mw-collection-chip';button.textContent = text;
        const icon = $('[data-collection-close] svg',drawer).cloneNode(true);button.append(icon);button.setAttribute('aria-label','Remove '+text+' filter');
        button.addEventListener('click', () => {if(key==='price'){applied.min=null;applied.max=null;}else applied[key]=applied[key].filter(item=>item!==value);commit();});active.append(button);
      };
      keys.forEach(key => applied[key].forEach(value => chip(key === 'availability' ? value === 'in' ? 'In stock' : 'Out of stock' : value,key,value)));
      if(applied.min!==null || applied.max!==null) chip(money(applied.min??0)+' – '+money(applied.max??maxPrice),'price');
      active.hidden = active.children.length === 0;
      const badge = $('[data-filter-count]',section);badge.textContent = String(active.children.length);badge.hidden = !active.children.length;
    }
    function commit() {
      limit = pageSize;history.pushState(null,'',stateUrl(applied,location.href));fillForm(applied);render();
    }
    form.addEventListener('submit', event => {
      event.preventDefault();if(!ready || !form.reportValidity())return;
      applied = formState();commit();closeDrawer();
    });
    $$('[data-collection-clear]', section).forEach(button => button.addEventListener('click', () => {
      if(!ready)return;applied=emptyState();commit();updateCounts();
    }));
    more.addEventListener('click', () => {limit += pageSize;render();});
    const sort = $('[data-collection-sort]',section), sortTrigger = $('summary',sort), sortOptions = $$('[data-collection-sort-value]',sort);
    const positionSort=()=>{
      if(!sort.open)return;
      const box=sort.getBoundingClientRect(),below=innerHeight-box.bottom-16,above=box.top-16,up=below<Math.min(240,above);
      sort.classList.toggle('is-above',up);
      sort.style.setProperty('--sort-menu-height',Math.max(80,up?above:below)+'px');
    };
    sort.addEventListener('toggle',positionSort);
    addEventListener('resize',positionSort);
    addEventListener('scroll',positionSort,{passive:true});
    sort.addEventListener('click',event => {
      const option=event.target.closest('[data-collection-sort-value]');
      if(!option||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();sort.open=false;
      const url=stateUrl(applied,location.href);url.searchParams.set('sort_by',option.dataset.collectionSortValue);location.assign(url);
    });
    sort.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();sort.open=false;sortTrigger.focus();return;}
      if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
      event.preventDefault();sort.open=true;positionSort();
      const index=sortOptions.indexOf(document.activeElement),current=sortOptions.findIndex(option=>option.hasAttribute('aria-current'));
      const next=event.key==='Home'?0:event.key==='End'?sortOptions.length-1:index<0?Math.max(0,current):(index+(event.key==='ArrowDown'?1:-1)+sortOptions.length)%sortOptions.length;
      sortOptions[next]?.focus();
    });
    sort.addEventListener('focusout',event=>{if(!sort.contains(event.relatedTarget))sort.open=false;});
    const closeSortOutside=event=>{if(!sort.contains(event.target))sort.open=false;};
    document.addEventListener('click',closeSortOutside);
    const onPopState=()=>{if(!ready)return;applied=readState(location.search);limit=pageSize;fillForm(applied);render();};
    addEventListener('popstate',onPopState);
    section.mwCollectionCleanup=()=>{clearTimeout(closingTimer);removeEventListener('popstate',onPopState);removeEventListener('resize',positionSort);removeEventListener('scroll',positionSort);document.removeEventListener('click',closeSortOutside);if(drawer.open)drawer.close();};
    async function load() {
      open.disabled = true;count.textContent = `${Math.min(pageSize,products.length)} of ${total} products`;
      products.forEach((product,index)=>product.node.hidden=index>=pageSize);
      try {
        for(let page=1;page<=pages;page++) {
          if(page===Number(section.dataset.currentPage))continue;
          const url = new URL(section.dataset.collectionUrl,location.origin);url.searchParams.set('section_id',section.dataset.sectionId);url.searchParams.set(section.dataset.pageParam||'page',String(page));
          const sort = new URLSearchParams(location.search).get('sort_by');if(sort)url.searchParams.set('sort_by',sort);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Unable to load the collection.');
          const html=new DOMParser().parseFromString(await response.text(),'text/html'),chunk=$('[data-collection-section]',html);
          if(!chunk)throw new Error('Unable to load the collection.');collect(chunk,page);
        }
        products.sort((a,b)=>a.order-b.order);products.forEach(product=>grid.append(product.node));
        maxPrice = products.reduce((highest,product)=>product.variants.reduce((value,variant)=>Math.max(value,variant.price),highest),0);
        buildFacets();fillForm(applied);ready=true;open.disabled=false;$('[data-collection-pagination]',section).hidden=true;render();
      } catch (reason) {
        error.hidden=false;error.textContent='Some products could not be loaded. Reload this page to use filters, or browse the pages below.';
        $('[data-collection-pagination]',section).hidden=false;
        products.forEach(product=>product.node.hidden=false);count.textContent=`${products.length} of ${total} products`;
      }
    }
    load();
  }
  function initialize(scope=document) {$$('[data-collection-section]',scope).forEach(setup);}
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>$$('[data-collection-section]',event.target).forEach(section=>section.mwCollectionCleanup?.()));
})();
